export default __webpack_public_path__ + "static/media/cx_cover_cal12s.b01d78fd.jpeg";